import { Component } from "react";
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Label,
} from "reactstrap"
import Switch from "react-switch"
import { AvForm, AvField, AvInput } from "availity-reactstrap-validation"
import { isEmpty } from "lodash"


class AstroUserDetails extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isOpen: true,
      user: props.user,
      onSubmit: props.onSubmit,
      onMakeDefault: props.onMakeDefault,
      onClosed: props.onClosed,

    }
  }





  render() {
    const { user, isOpen, onSubmit, onClosed } = this.state

    let updating = user.id !== undefined && user.id > 0;
    const Offsymbol = () => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: 2
          }}
        >
          {" "}
          No
        </div>
      )
    }
    const OnSymbol = props => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: 2
          }}
        >
          {"             "}
          Yes
        </div>
      )
    }


    return (
      <Modal
        size="lg"
        isOpen={isOpen}
        toggle={() => {
          this.setState({ isOpen: false });
          onClosed();
        }}
        centered={true}
        backdrop="static"
      >
        <ModalHeader
          toggle={() => {
            this.setState({ isOpen: false });
            onClosed();
          }}
        >
        </ModalHeader>
        <AvForm
          className="form-horizontal"
        >
          <ModalBody>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="firstname"
                    id="firstname"
                    label="First Name"
                    value={user.firstName}
                    className="form-control"
                    type="text"
                    placeholder="Enter First Name"
                    errorMessage="Invalid First Name"
                    disabled
                    minLength="1"
                    maxLength="255"
                    onChange={(event) => {
                      user.firstName = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="lastname"
                    id="lastname"
                    label="Last Name"
                    value={user.lastName}
                    className="col-md-6"
                    type="text"
                    placeholder="Enter Last Name"
                    errorMessage="Invalid Last Name"
                    disabled
                    minLength="1"
                    maxLength="10"
                    onChange={(event) => {
                      user.lastName = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="address"
                    id="address"
                    label="Address"
                    value={user.address1}
                    className="form-control"
                    type="text"
                    placeholder="Enter  Address"
                    errorMessage="Invalid Address"
                    disabled
                    minLength="1"
                    maxLength="255"
                    onChange={(event) => {
                      user.address1 = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="address2"
                    id="address2"
                    label="address"
                    value={user.address2}
                    className="col-md-6"
                    type="text"
                    placeholder="Enter address"
                    errorMessage="Invalid address"
                    disabled
                    minLength="1"
                    maxLength="10"
                    onChange={(event) => {
                      user.address2 = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="city"
                    id="city"
                    label="City"
                    value={user.city}
                    className="col-md-6"
                    type="text"
                    placeholder="Enter City"
                    errorMessage="Invalid City"
                    disabled
                    minLength="1"
                    maxLength="255"
                    onChange={(event) => {
                      user.city = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="state"
                    id="state"
                    label="State"
                    value={user.state}
                    className="col-md-6"
                    type="text"
                    countryholder="Enter State"
                    errorMessage="Invalid State"
                    disabled
                    minLength="1"
                    maxLength="255"
                    onChange={(event) => {
                      user.State = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="country"
                    id="country"
                    label="Country"
                    value={user.country}
                    className="col-md-6"
                    type="text"
                    placeholder="Enter Country"
                    errorMessage="Invalid Country"
                    disabled
                    minLength="1"
                    maxLength="255"
                    onChange={(event) => {
                      user.country = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>


              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="mobile"
                    id="mobile"
                    label="Mobile"
                    value={user.mobile}
                    className="col-md-6"
                    type="text"
                    placeholder="Enter Mobile"
                    errorMessage="Invalid Mobile"
                    disabled
                    minLength="1"
                    maxLength="255"
                    onChange={(event) => {
                      user.mobile = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <AvField
                    name="username"
                    id="username"
                    label="User Name"
                    value={user.username}
                    className="form-control"
                    type="text"
                    placeholder="Enter User Name"
                    errorMessage="Invalid User Name"
                    disabled
                    minLength="1"
                    maxLength="255"
                    onChange={(event) => {
                      user.username = event.target.value;
                      this.setState({
                        user
                      })
                    }}
                  />
                </div>
              </Col>

            </Row>
            <Row>
              <Col>
                Activated : {"  "}
                <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  className="me-1 mb-sm-8"
                  onColor="#02a499"
                  onChange={() =>
                    this.setState({ active: !this.state.active })
                  }
                  checked={this.state.active}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col lg={12}>

                <button
                  type="button"
                  className="btn btn-primary mr-1 "
                  onClick={() => {
                    if (user.firstName === undefined || user.firstName === null || isEmpty(user.firstName)) {
                      return;
                    }
                    if (user.email === undefined || user.email === null || isEmpty(user.email)) {
                      return;
                    }
                    if (user.mobile === undefined || user.mobile === null || isEmpty(user.mobile)) {
                      return;
                    }
                    if (user.country === undefined || user.country === null || isEmpty(user.country)) {
                      return;
                    }
                    this.setState({ isOpen: false });
                    onSubmit(user);
                  }}
                >
                  Submit
                  </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    this.setState({ isOpen: false });
                    onClosed();
                  }}
                >
                  Close
                  </button>

              </Col>
            </Row>
          </ModalFooter>
        </AvForm>

      </Modal >
    );
  }
}

AstroUserDetails.propTypes = {
  user: PropTypes.object,
  onClosed: PropTypes.func,
  onSubmit: PropTypes.func,
}

//const mapStateToProps = ({edgeDevicesReducer}) => ({
// })
//const mapDispatchToProps = dispatch => ({
//})

//export default connect(mapStateToProps, mapDispatchToProps)(AstroDetails)

export default AstroUserDetails